import { z } from "zod";

export const stateSchema = z.object({
  state: z.string().min(1, "Please select an option"),
});

export const visitTypePreferenceSchema = z.object({
  visitType: z.string().min(1, "Please select an option"),
});

export const officePreferenceSchema = z.object({
  office: z.string().min(1, "Please select an option"),
});
